import { render, staticRenderFns } from "./ProdStats.vue?vue&type=template&id=8975cd96&"
import script from "./ProdStats.vue?vue&type=script&lang=js&"
export * from "./ProdStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports